import { IPlayerState } from '../../../State/Player/IPlayerState';
import IPlayerData from '../../IPlayerData';
import { restoreNumber } from '../../ParseHelper';
import PlayerProperty from '../PlayerProperty';

export default class Keys extends PlayerProperty<
    number,
    {
        map_n: number;
    }
> {
    public readonly defaultValue: number = 1;

    public restore(playerEndpointData: IPlayerData): number {
        return restoreNumber(playerEndpointData.map_n, this.defaultValue);
    }

    public save(playerStateData: IPlayerState) {
        return { map_n: playerStateData.world };
    }

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return playerStateData.world !== playerEndpointData.map_n;
    }
}
